<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'webhooksCrud'"
          crudName="Webhooks"
          newText="Novo Webhook"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="false"
          :enableDownloadExcel="false"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableActive="true"
          :enableView="true"
          :enableSenhaPath="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "webhooksTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "nome", "url", "eventos", "ativo", "actions"],
      tableData: ["id", "nome", "url", "eventos", "ativo"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome", "url"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          url: "URL",
          eventos: "Eventos",
          ativo: "Ativo",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          eventos(h, row, index) {
            const labels = {
              senha_gerada: "Senha gerada",
              mudanca_setor: "Mudança de setor",
            };
            const eventos = row.eventos || [];
            return (
              <span>
                {eventos.map((evento) => (
                  <span class="badge badge-primary mr-1">
                    {labels[evento] || evento}
                  </span>
                ))}
              </span>
            );
          },
          ativo(h, row, index) {
            return row.ativo ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "webhooks/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        url: "url",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
